import { useEffect } from 'react';

export function useDataDogSessionReplay() {
    useEffect(() => {
        if (window.DD_RUM) {
            console.log('Starting DataDog Session Recording');
            window.DD_RUM.startSessionReplayRecording();
        }
    }, []);
}
